export enum MinorNightWorkRule {
  ABSOLUTE_PROHIBITION = 'MinorNightWorkAbsoluteProhibition',
  UNDER_16 = 'MinorNightWorkUnder16',
  AGE_16_17 = 'MinorNightWork1617',
}
